import styled from 'styled-components';

export const ProductCardStyle = styled.div`
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.09);
  @media (min-width: 720px) {
    width: ${(props) =>
      props.showNewProductVideoCardUx
        ? props.horizontal
          ? '30%'
          : '120%'
        : props.horizontal
          ? '25%'
          : '100%'};
    min-width: ${(props) =>
      props.showNewProductVideoCardUx
        ? props.carousel
          ? '330px'
          : '120%'
        : props.carousel
          ? '300px'
          : ''};
  }
  @media (max-width: 720px) {
    flex-basis: ${(props) => (props.showNewProductVideoCardUx ? '60%' : '50%')};
    flex-shrink: 0;
    margin: 4px;
    min-width: ${(props) =>
      props.showNewProductVideoCardUx
        ? props.carousel
          ? '210px'
          : '120%'
        : props.carousel
          ? '200px'
          : ''};
  }

  .topStrip {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 2;
    @media (max-width: 720px) {
      margin-left: 15px;
    }
  }

  .productNameNew {
    font-size: clamp(13px, 2vw, 18px);
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
  }

  .imgWrapper {
    position: relative;
    padding-top: 100%;
    width: ${(props) => (props.showNewProductVideoCardUx ? '100%' : '')};
    border-top-right-radius: ${(props) =>
      props.showNewProductVideoCardUx ? '' : '6px'};
    border-top-left-radius: ${(props) =>
      props.showNewProductVideoCardUx ? '' : '6px'};
  }

  img {
    border-top-right-radius: 6px !important;
    border-top-left-radius: 6px !important;
  }

  padding-bottom: ${(props) => (props.extraPadding ? '40px' : '0')};
  margin: 4px 0;
  border-radius: ${(props) => (props.singleProduct ? '16px' : '8px')};
  box-shadow: ${(props) =>
    props.store ? '' : ' 1px 1px 14px -10px rgba(0, 0, 0, 0.7)'};

  .productName {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
    font-size: clamp(14px, 2vw, 16px);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .snippetSection {
    display: flex;
    align-items: center;
    column-gap: 8px;
    margin: 8px 0;
  }

  .snippetText {
    color: #898989bd;
    padding-right: 10px;
    border-right: 1px solid #b8b8b8;
    font-size: clamp(0.65em, 2vw, 0.85em);
    font-weight: 500;

    &:last-child {
      border: none;
    }
  }

  .detailsSection {
    .category {
      font-size: clamp(9px, 2vw, 14px);
      color: rgba(0, 0, 0, 0.6);
      font-weight: 500;
      margin-bottom: 4px;
      text-transform: uppercase;
    }

    .productNameNew {
      margin: ${(props) => (props.isAllCategoryPage ? '0px' : '')};
      @media (max-width: 720px) {
        display: ${(props) =>
          props.isForJoyfulPage || props.isAllCategoryPage
            ? '-webkit-box'
            : ''};
        -webkit-line-clamp: ${(props) =>
          props.isForJoyfulPage || props.isAllCategoryPage ? '3' : ''};
        -webkit-box-orient: ${(props) =>
          props.isForJoyfulPage || props.isAllCategoryPage ? 'vertical' : ''};
        overflow: ${(props) =>
          props.isForJoyfulPage || props.isAllCategoryPage ? 'hidden' : ''};
      }
    }

    padding: ${(props) => (!props.store ? '10px 10px 55px' : '10px 10px 17px')};
    background-color: white;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    @media (max-width: 720px) {
      padding: ${(props) =>
        props.store ? '10px 10px 10px' : '10px 10px 50px'};
    }
  }

  .freeShipStrip {
    display: flex;
    align-items: center;
    column-gap: 6px;

    img {
      width: 18px;
    }

    p {
      color: #888;
      font-weight: 500;
      font-size: clamp(10px, 2vw, 12px);
    }
  }

  &.active {
    opacity: 0.4;
  }

  animation: scaleIn 1s ease-in-out;
  @keyframes scaleIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .comboSavingText {
    font-size: clamp(13px, 2vw, 15px);
    padding: 8px;
    background: #facf46;
    width: max-content;
    margin: 12px 0;
    font-weight: 500;
    border-radius: 2px;
    color: rgba(0, 0, 0, 0.87);
    overflow: hidden;
    position: relative;

    span {
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      background: linear-gradient(
        105deg,
        transparent 10%,
        rgb(255 255 255) 25%,
        transparent 30%,
        transparent 50%
      );

      width: 120%;
      height: 100%;
      animation: move_continue 2s;
      animation-iteration-count: infinite;
      animation-delay: 1s;
    }

    @keyframes move_continue {
      0% {
        left: 0;
        opacity: 0;
      }
      5% {
        opacity: 0;
      }
      48% {
        opacity: 0.3;
      }
      80% {
        opacity: 0;
      }
      100% {
        left: 82%;
      }
    }
  }

  &.singleProduct {
    a {
      @media (max-width: 768px) {
        padding: 12px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        .imgWrapper {
          flex-basis: 33%;
          flex-shrink: 0;
          padding-top: 33%;

          img {
            border-radius: 16px !important;
          }
        }

        gap: 10px;
        .detailsSection {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0;
        }
      }
    }
  }
`;
export const ProductFlag = styled.div`
  background: ${(props) =>
    props.flagData ? props.flagData?.bgColor : '#d9eae0'};
  color: ${(props) => (props.flagData ? props.flagData?.textColor : '#000')};
  padding: 6px;
  position: absolute;
  right: 0;
  top: 0;
  border-top-right-radius: 6px;
  z-index: 1;
  border-bottom-left-radius: 6px;
  font-size: clamp(12px, 2vw, 14px);
  overflow: hidden;
  font-weight: 500;

  span {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    background: linear-gradient(
      105deg,
      transparent 10%,
      rgb(255 255 255) 25%,
      transparent 30%,
      transparent 50%
    );

    width: 120%;
    height: 100%;
    animation: move_continue 2s;
    animation-iteration-count: infinite;
    animation-delay: 1s;
  }

  @keyframes move_continue {
    0% {
      left: 0;
      opacity: 0;
    }
    5% {
      opacity: 0;
    }
    48% {
      opacity: 0.3;
    }
    80% {
      opacity: 0;
    }
    100% {
      left: 82%;
    }
  }
`;
export const PriceDetailNew = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.store ? 'center' : '')};
  column-gap: ${(props) =>
    props.noGap ? '' : props.isAllCategoryPage ? '2px' : '8px'};
  margin-bottom: 10px;
  padding-bottom: ${(props) => (props.store ? '12px' : '')};
  padding-top: ${(props) => (props.paddingTop ? '10px' : '')};
  @media (max-width: 720px) {
    margin-bottom: ${(props) => (props.singleProduct ? '10px' : '0px')};
  }

  .sellingPrice {
    font-size: clamp(16px, 2vw, 18px);
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
  }

  .mainPrice {
    font-weight: 500;
    padding-right: 8px;
    font-size: clamp(14px, 2vw, 18px);
  }

  .strikePriceCat {
    text-decoration: line-through;
    font-size: clamp(13px, 2vw, 14px);
    padding-right: 8px;
    font-weight: 500;
    color: #9d9d9d;
  }

  .discountCat {
    font-size: clamp(13px, 2vw, 14px);
    color: #63b0a8;
    font-weight: 600;
  }

  .strikePrice {
    font-size: clamp(14px, 2vw, 16px);
    color: #898989;
    text-decoration: line-through;
    border-right: 1px solid #b8b8b8;
    padding-right: 8px;
  }

  .discount {
    font-weight: 600;
    font-size: clamp(12px, 2vw, 14px);
    color: #20b2aacc;
  }

  .pricePerCount {
    color: rgb(0 0 0 / 38%);
    font-size: clamp(9px, 2vw, 12px);
    @media (min-width: 768px) {
      margin-right: 15px;
    }
  }
`;
export const PriceDetailVideo = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.store ? 'center' : '')};
  column-gap: 8px;
  margin-bottom: 10px;
  padding: 0px 8px 12px;
  @media (max-width: 720px) {
    margin-bottom: 0px;
  }
  .sellingPrice {
    font-size: clamp(14px, 2vw, 18px);
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
  }
  .strikePrice {
    font-size: clamp(12px, 2vw, 16px);
    color: #898989;
    text-decoration: line-through;
    border-right: 1px solid #b8b8b8;
    padding-right: 8px;
  }
  .discount {
    font-weight: 600;
    font-size: clamp(10px, 2vw, 14px);
    color: #20b2aacc;
  }
`;
export const RatingSectionNew = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
  margin-bottom: 10px;
  margin-top: ${(props) => (props.store ? '15px' : '')};
  @media (max-width: 720px) {
    margin-top: ${(props) => (props.store ? '9px' : '')};
  }

  img {
    width: 20px;
  }

  p {
    font-weight: 500;
    font-size: clamp(14px, 2vw, 16px);
  }

  span {
    color: #898989bd;
    font-weight: 500;
    font-size: clamp(12px, 2vw, 14px);
  }
`;
